import { render } from "./BurgerForm.vue?vue&type=template&id=ad7ea508&scoped=true"
import script from "./BurgerForm.vue?vue&type=script&lang=js"
export * from "./BurgerForm.vue?vue&type=script&lang=js"

import "./BurgerForm.vue?vue&type=style&index=0&id=ad7ea508&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Make_your_burger/Make_your_burger/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7ea508"]])

export default __exports__